const c = (e) => {
  if ((e == null ? void 0 : e.type) !== "text" || !e.providerMetadata || !e.providerMetadata.raw || !e.providerMetadata.raw.data)
    return null;
  if (typeof e.providerMetadata.raw.data != "string")
    return e.providerMetadata.raw.data;
  let t;
  try {
    t = JSON.parse(e.providerMetadata.raw.data);
  } catch (r) {
    console.error("invalid raw data");
  }
  return t || e.providerMetadata.raw.data;
}, S = (e) => {
  if ((e == null ? void 0 : e.type) === "error")
    return !0;
  const t = c(e);
  return (t == null ? void 0 : t.type) === "agent-error";
}, R = (e) => {
  const t = c(e);
  return (t == null ? void 0 : t.type) === "agent-fake-msg";
}, T = (e) => (e == null ? void 0 : e.type) === "file", D = (e) => {
  const t = c(e);
  return (t == null ? void 0 : t.type) === "query-stream-parsed-info";
}, O = (e) => {
  const t = c(e);
  if ((t == null ? void 0 : t.type) !== "query-stream-parsed-info")
    return null;
  const r = t.result;
  console.log("query result raw data:", r);
  try {
    return JSON.parse(r);
  } catch (n) {
    return console.error("invalid query result data"), null;
  }
}, F = (e) => {
  if (!Array.isArray(e))
    return !1;
  for (const t of e)
    if ((t == null ? void 0 : t.type) === "file")
      return !0;
  return !1;
}, I = (e) => {
  const t = c(e);
  return (t == null ? void 0 : t.type) === "agent-loading";
}, B = (e) => {
  const t = c(e);
  return (t == null ? void 0 : t.type) !== "agent-loading" ? "" : (t == null ? void 0 : t.label) || "加载中";
}, L = (e) => {
  if (!S(e))
    return "";
  if (e != null && e.errorText)
    return e.errorText;
  const t = c(e);
  return (t == null ? void 0 : t.error) || "未知错误";
}, W = (e) => {
  if (e != null && e.errorText)
    return e.errorText;
  const t = c(e);
  return (t == null ? void 0 : t.error) || "未知错误";
}, g = "data-shadow-slot-injected", U = (e, t) => {
  if (e.querySelector(`[${g}]`)) return;
  const r = (a) => {
    const i = a.cloneNode(!0);
    i.setAttribute(g, ""), e.appendChild(i);
  };
  document.head.querySelectorAll("style").forEach(r), document.head.querySelectorAll('link[rel="stylesheet"]').forEach(r);
  let n = t.parentNode;
  for (; n; )
    n instanceof ShadowRoot && (n.querySelectorAll("style").forEach(r), n.querySelectorAll('link[rel="stylesheet"]').forEach(r)), n = n.parentNode;
};
function w(e) {
  return Array.isArray(e) ? e.every((t) => typeof t == "string") : !1;
}
function q(e) {
  return Array.isArray(e) ? e.every(
    (t) => typeof t == "object" && t !== null && "label" in t && "value" in t && typeof t.label == "string" && typeof t.value == "string"
  ) : !1;
}
const G = (e) => w(e) ? e.join(", ") : q(e) ? e.map((r) => r.value).join(", ") : e, C = /* @__PURE__ */ new Set([
  "password",
  "textarea",
  "datetime",
  "text",
  "radiogroup",
  "radio",
  "combo",
  "combocheck",
  "checkboxgroup",
  "number"
]), j = (e) => Array.isArray(e) ? e.filter((t) => t.widget ? C.has(t.widget.type) : !1) : [], J = (e) => (t) => {
  const r = c(t);
  return (r == null ? void 0 : r.type) === e;
}, H = (e) => (t) => {
  const r = c(t);
  return (r == null ? void 0 : r.type) !== e ? null : (r == null ? void 0 : r.field) || null;
}, Q = (e) => (t) => Array.isArray(t) && t.length > 0 ? t.filter(e) : e(t) ? [t] : [], $ = (e) => {
  try {
    return JSON.parse(e);
  } catch (t) {
    return console.error("Failed to parse JSON:", t), null;
  }
}, Y = 10, z = (e, t = "image/png") => new Promise((r) => {
  const n = new Image();
  n.crossOrigin = "anonymous", n.onload = () => {
    const a = document.createElement("canvas");
    a.width = n.naturalWidth, a.height = n.naturalHeight, a.getContext("2d").drawImage(n, 0, 0), r(a.toDataURL(t));
  }, n.onerror = () => r(e), n.src = e;
}), K = {
  eq: "等于",
  neq: "不等于",
  gt: "大于",
  lt: "小于",
  gte: "大于等于",
  lte: "小于等于",
  contains: "包含",
  not_contains: "不包含",
  in: "等于任意",
  nin: "不等于任意",
  all: "包含所有",
  empty: "为空",
  not_empty: "不为空",
  range: "范围"
}, v = {
  // Text-like: equality, fuzzy, empty checks
  text: ["eq", "neq", "in", "nin", "contains", "not_contains", "empty", "not_empty"],
  password: ["eq", "neq", "contains", "not_contains", "empty", "not_empty"],
  radiogroup: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  radio: ["eq", "neq", "empty", "not_empty"],
  combo: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  sn: ["eq", "neq", "in", "nin", "contains", "not_contains", "empty", "not_empty"],
  // Textarea: fuzzy matching
  textarea: ["contains", "not_contains", "empty", "not_empty"],
  // Number: comparison operators
  number: ["eq", "neq", "gt", "gte", "lt", "lte", "range", "empty", "not_empty"],
  // DateTime: comparison operators
  datetime: ["eq", "neq", "gte", "lte", "range", "empty", "not_empty"],
  // Multi-select: membership, intersection
  checkboxgroup: ["in", "all", "eq", "empty", "not_empty"],
  combocheck: ["in", "all", "eq", "empty", "not_empty"],
  // User/Dept: equality and membership
  user: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  dept: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  // Groups: membership, intersection, empty
  usergroup: ["in", "all", "eq", "empty", "not_empty"],
  deptgroup: ["in", "all", "eq", "empty", "not_empty"],
  // Address/Location: intersection
  address: ["in", "nin", "empty", "not_empty"],
  location: ["in", "nin", "empty", "not_empty"],
  // Files: empty checks
  upload: ["empty", "not_empty"],
  image: ["empty", "not_empty"],
  signature: ["empty", "not_empty"],
  // Flow state
  flowState: ["eq", "neq", "empty"],
  flowstate: ["eq", "neq", "empty"],
  // Link data: combo-like
  linkdata: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  linkquery: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  dataload: ["eq", "neq", "in", "nin", "empty", "not_empty"],
  // Formula
  formula: ["eq", "neq", "empty", "not_empty"],
  // Display-only: no meaningful operators
  separator: [],
  button: [],
  subform: [],
  unknown: []
}, _ = {
  text: "eq",
  password: "eq",
  radiogroup: "eq",
  radio: "eq",
  combo: "eq",
  sn: "eq",
  textarea: "contains",
  number: "range",
  datetime: "range",
  checkboxgroup: "all",
  combocheck: "all",
  user: "eq",
  dept: "eq",
  usergroup: "all",
  deptgroup: "all",
  address: "all",
  location: "all",
  upload: "not_empty",
  image: "not_empty",
  signature: "not_empty",
  flowState: "eq",
  flowstate: "eq",
  linkdata: "eq",
  linkquery: "eq",
  dataload: "eq",
  formula: "eq"
};
function X(e) {
  var t;
  return e ? (t = v[e]) != null ? t : [] : [];
}
function Z(e) {
  var t;
  return e && (t = _[e]) != null ? t : "eq";
}
function d(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function b(e) {
  return d(e) ? e : null;
}
function m(e) {
  return !!(e == null || e === "" || Array.isArray(e) && e.length === 0);
}
function y(e, t) {
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length) return !1;
    const r = e.map(String).sort(), n = t.map(String).sort();
    return r.every((a, i) => a === n[i]);
  }
  if (d(e) && d(t)) {
    const r = Object.keys(e), n = Object.keys(t);
    return r.length !== n.length ? !1 : r.every((a) => String(e[a]) === String(t[a]));
  }
  return String(e) === String(t);
}
function h(e, t) {
  if (d(t)) {
    const n = b(e);
    return !(!n || t.province !== void 0 && String(n.province) !== String(t.province) || t.city !== void 0 && String(n.city) !== String(t.city) || t.district !== void 0 && String(n.district) !== String(t.district));
  }
  const r = Array.isArray(t) ? t.map(String) : [];
  return Array.isArray(e) ? e.some((n) => r.includes(String(n))) : r.includes(String(e));
}
function k(e, t) {
  const r = Array.isArray(t) ? t.map(String) : [];
  if (r.length === 0) return !1;
  const n = Array.isArray(e) ? e.map(String) : [];
  return r.every((a) => n.includes(a));
}
function x(e, t) {
  const r = b(t);
  if (!r) return !1;
  const n = Number(e);
  return !(isNaN(n) || r.min !== void 0 && r.min !== null && n < Number(r.min) || r.max !== void 0 && r.max !== null && n > Number(r.max));
}
function P(e, t) {
  var o;
  const r = (o = e.field.widget) == null ? void 0 : o.widgetName;
  if (!r) return !1;
  const n = t[r], { operator: a, value: i } = e;
  switch (a) {
    case "empty":
      return m(n);
    case "not_empty":
      return !m(n);
    case "eq":
      return y(n, i);
    case "neq":
      return !y(n, i);
    case "contains":
      return String(n).includes(String(i));
    case "not_contains":
      return !String(n).includes(String(i));
    case "gt":
      return Number(n) > Number(i);
    case "gte":
      return Number(n) >= Number(i);
    case "lt":
      return Number(n) < Number(i);
    case "lte":
      return Number(n) <= Number(i);
    case "in":
      return h(n, i);
    case "nin":
      return !h(n, i);
    case "all":
      return k(n, i);
    case "range":
      return x(n, i);
    default:
      return !1;
  }
}
function V(e, t) {
  const r = e.triggerCondition;
  if (!r) return !0;
  if (!e.enabled)
    return !1;
  const { items: n, quantifier: a } = r;
  if (!n || n.length === 0) return !0;
  const i = n.map((o) => P(o, t));
  return a === "any" ? i.some((o) => o) : i.every((o) => o);
}
const E = {
  eq: "eq",
  neq: "ne",
  gt: "gt",
  gte: "gte",
  lt: "lt",
  lte: "lte",
  contains: "like",
  not_contains: "unlike",
  in: "in",
  nin: "nin",
  all: "all",
  empty: "empty",
  not_empty: "not_empty",
  range: "range"
}, N = {
  eq: "eq",
  ne: "neq",
  gt: "gt",
  gte: "gte",
  lt: "lt",
  lte: "lte",
  like: "contains",
  unlike: "not_contains",
  in: "in",
  nin: "nin",
  all: "all",
  empty: "empty",
  not_empty: "not_empty",
  range: "range"
};
function ee(e) {
  const t = e.quantifier === "any" ? "or" : "and", r = e.items.map((n) => {
    var o, l, s, u, f, p;
    const a = (o = E[n.operator]) != null ? o : "eq";
    let i;
    return n.operator === "range" && d(n.value) ? i = [n.value.min, n.value.max] : Array.isArray(n.value) ? i = n.value : i = [n.value], {
      field: (u = (s = (l = n.field) == null ? void 0 : l.widget) == null ? void 0 : s.widgetName) != null ? u : "",
      method: a,
      value: i,
      type: (p = (f = n.field) == null ? void 0 : f.widget) == null ? void 0 : p.type
    };
  });
  return JSON.stringify({ rel: t, cond: r });
}
function te(e) {
  const t = JSON.parse(e), r = t.rel === "or" ? "any" : "all", n = t.cond.map((a, i) => {
    var s, u;
    const o = (s = N[a.method]) != null ? s : "eq";
    let l = a.value;
    return o === "range" ? l = { min: a.value[0], max: a.value[1] } : ["eq", "neq", "contains", "not_contains", "gt", "gte", "lt", "lte"].includes(o) && (l = a.value[0]), {
      id: `${a.field}_${i}`,
      field: {
        label: a.field,
        widget: {
          widgetName: a.field,
          type: (u = a.type) != null ? u : "unknown",
          value: void 0
        }
      },
      operator: o,
      value: l
    };
  });
  return { targetName: "", quantifier: r, items: n };
}
function ne(e, t, r = 1) {
  const n = [], a = [];
  for (const i of e)
    t(i) ? a.push(i) : (a.length > 0 && (n.push(a.length >= r ? [...a] : a[0]), a.length = 0), n.push(i));
  return a.length > 0 && n.push(a.length >= 2 ? [...a] : a[0]), n;
}
function A(e) {
  const t = [];
  for (const r of e)
    Array.isArray(r) ? t.push(...A(r)) : t.push(r);
  return t;
}
const M = {
  projectdevelopment: "e914",
  resourcelibrary: "e915",
  Plugin2: "e90e",
  Plugin: "e90f",
  JSON: "e910",
  Dropdown: "e911",
  Batchprocessing: "e912",
  "Image-text": "e916",
  Newaddition: "e917",
  reportforms: "e918",
  AddFola: "e919",
  delete: "e91a",
  AddImage: "e91b",
  Send: "e91c",
  text: "e91d",
  image: "e91e",
  Star1: "e91f",
  Ellipse: "e920",
  "Ellipse-Copy": "e921",
  Shape: "e922",
  "Shape-Copy": "e923",
  "right-line": "e924",
  "right-arrow": "e925",
  "double-right-arrow": "e926",
  ellipse: "e927",
  Rectangle: "e928",
  "Rectangle-Copy": "e929",
  "Rectangle-Copy-2": "e92a",
  CombinedShape: "e92b",
  Line: "e92c",
  time: "e92d",
  calendar: "e92e",
  richsinglelinetext: "e92f",
  singlelinetext: "e930",
  multilinetext: "e931",
  number: "e932",
  RichText: "e933",
  image1: "e934",
  Attachment: "e935",
  Phone: "e936",
  Email: "e937",
  date: "e938",
  "Multiple-choice": "e939",
  Checkbox: "e93a",
  "Drop-down": "e93b",
  positioning: "e93c",
  Description: "e93d",
  AutoNumber: "e93e",
  Address: "e93f",
  Staff: "e940",
  Department: "e941",
  Switch: "e942",
  Slider: "e943",
  Currentdate: "e944",
  Grade: "e945",
  Barcode: "e946",
  Subtable: "e947",
  associatedtable: "e948",
  Associatedapplication: "e949",
  Referencefield: "e94a",
  Uppercasing: "e94b",
  nodata: "e94c",
  "X-mark": "e94d",
  Copy: "e94e",
  Correct: "e94f",
  Save: "e950",
  Printer: "e951",
  search: "e952",
  filter: "e953",
  Export: "e954",
  Import: "e955",
  Customprint: "e956",
  refresh: "e957",
  Helpcenter: "e958",
  Tutorial: "e959",
  Release: "e95a",
  more: "e95b",
  Setup: "e95c",
  sort: "e95d",
  Back: "e95e",
  show: "e95f",
  hide: "e960",
  Preview: "e961",
  Click: "e962",
  Allcheck: "e963",
  Cancelcheck: "e964",
  Likespot: "e965",
  Favoritespot: "e966",
  Followspot: "e967",
  Commentspot: "e968",
  At: "e969",
  Pin: "e96a",
  edit: "e96b",
  Top: "e96c",
  Movein: "e96d",
  Moveout: "e96e",
  Forward: "e96f",
  Revoke: "e970",
  Return: "e971",
  Link: "e972",
  Unlink: "e973",
  Download: "e974",
  Upload: "e975",
  Download2: "e976",
  Upload2: "e977",
  Comment: "e978",
  Remind: "e979",
  Notice: "e97a",
  Permission: "e97b",
  SMS: "e97c",
  QRcode: "e97d",
  Website: "e97e",
  Monitoring: "e97f",
  Api: "e980",
  Webhook: "e981",
  Synchronous: "e982",
  Automation: "e983",
  Trigger: "e984",
  Condition: "e985",
  Success: "e986",
  Failure: "e987",
  countdown: "e988",
  Waiting: "e989",
  Flow: "e98a",
  Connection: "e98b",
  Dashboard: "e98c",
  chart: "e98d",
  Piechart: "e98e",
  BarChart: "e98f",
  DoubleBarChart: "e991",
  StackedBarChart: "e992",
  PercentageStackedBarChart: "e993",
  LineChart: "e994",
  areachart: "e990",
  combinationchart: "e995",
  Scatterplot: "e996",
  FunnelChart: "e997",
  wordcloud: "e998",
  RadarChart: "e999",
  PivotTable: "e99a",
  NumberChart: "e99b",
  map: "e99c",
  Timeline: "e99d",
  Album: "e99e",
  Kanban: "e99f",
  Ganttchart: "e9a0",
  Circle: "e9a8",
  linesurface: "e9a1",
  IconStyle: "e9a2",
  Backgroundcolor: "e9a3",
  DeleteDe: "e9a4",
  AlignLeft: "e9a5",
  AlignCenter: "e9a6",
  AlignRight: "e9a7",
  Column: "e9a9",
  Component: "e9aa",
  Customcomponent: "e9ab",
  Title: "e9ac",
  RichText1: "e9ad",
  Carousel: "e9ae",
  PageTab: "e9af",
  Buriedpoint: "e9b0",
  Container: "e9b1",
  QuickStart: "e9b2",
  Group: "e9b3",
  Ungroup: "e9b4",
  Front: "e9b5",
  Back1: "e9b6",
  Lock: "e9b7",
  Unlock: "e9b8",
  Association: "e9b9",
  CancelAssociation: "e9ba",
  Quotation: "e9bb",
  ViewSet: "e9bc",
  AutoScale: "e9bd",
  waterfall: "e9be",
  watermark: "e9bf",
  history: "e9c0",
  Setting: "e9c1",
  Draftbox: "e9c2",
  SQL: "e9c3",
  Workflow: "e9c4",
  Workflow2: "e9c5",
  Addone: "e9c6",
  Formula: "e9c7",
  Dictionary: "e9c8",
  statistical: "e9c9",
  Recycle: "e9ca",
  Mistake: "e9cb",
  Tag: "e9cc",
  Pendingapproval: "e9cd",
  MyApplication: "e9ce",
  ApplicationApproval: "e9cf",
  Initiatedbyme: "e9d0",
  Copiedtome: "e9d1",
  Approvalnode: "e9d2",
  Fillnode: "e9d3",
  cc: "e9d4",
  Image1: "e9d5",
  Open: "e9d6",
  Color: "e9d7",
  Right: "e9d8",
  Backward: "e9d9",
  dataanalysis: "e9da",
  Filter2: "e9db",
  Freefilter: "e9dc",
  Conditionfilter: "e9dd",
  Quickfilter: "e9de",
  Export1: "e9df",
  Attachmentpreview: "e9e0",
  BulkEdit: "e9e1",
  Calculationrows: "e9e2",
  SingleSelect: "e9e3",
  dataview: "e9e4",
  Dataid: "e9e5",
  Divide: "e9e6",
  Progress: "e9e7",
  Star: "e9e8",
  Contacts: "e9e9",
  Activity: "e9ea",
  Minus: "e9eb",
  Plussign: "e9ec",
  "Plussign-Copy": "e9ed",
  Increased: "e9ee",
  Decline: "e9ef",
  indeterminate: "e9f0",
  Decline1: "e9f1",
  personal: "e9f2",
  Warning: "e9f3",
  Warning2: "e9f4",
  Prompt: "e9f5",
  info: "e9f6",
  Cancel: "e9f7",
  question1: "e9f8",
  Question: "e9f9",
  exclamation: "e9fa",
  Warning1: "e9fb",
  True: "e9fc",
  Suspended: "e9fd",
  Suspended1: "e9fe",
  Suspended2: "e9ff",
  Error: "ea00",
  CombinedShape2: "ea01",
  Delete1: "ea02",
  Circle1: "ea03",
  Decline2: "ea04",
  Decline3: "ea05",
  add: "ea06",
  Addto: "ea07",
  Reduce: "ea08",
  Subtract: "ea09",
  Addition: "ea0a",
  Multiplication: "ea0b",
  Division: "ea0c",
  Bracket: "ea0d",
  Reduce1: "ea0e",
  Search: "ea0f",
  Favorites: "ea10",
  Annotation: "ea11",
  Application: "ea12",
  Application2: "ea13",
  Applicationsview: "ea14",
  Publish: "ea15",
  Deploy: "ea16",
  Sidetoplowerside: "ea17",
  Narrow: "ea18",
  Backtothenavigation: "ea19",
  Forwardtothenavigation: "ea1a",
  Return1: "ea1b",
  Transfer: "ea1c",
  Log: "ea1d",
  table: "ea1e",
  Form: "ea1f",
  Openfield: "ea20",
  Closefield: "ea21",
  Receive: "ea22",
  Fill: "ea23",
  Fill1: "ea24",
  fillet: "ea25",
  rightangle: "ea26",
  round: "ea27",
  Send1: "ea28",
  Map: "ea29",
  Upward: "ea2a",
  Move: "ea2b",
  Downward: "ea2c",
  drag: "ea2d",
  TextIcon: "ea2e",
  Narrow1: "ea2f",
  Enlarge: "ea30",
  Enlarge2: "ea31",
  Cancel1: "ea32",
  Retract: "ea33",
  Expand: "ea34",
  Retract1: "ea35",
  Expand1: "ea36",
  Retract2: "ea37",
  Expand2: "ea38",
  Switch1: "ea39",
  Fullscreen: "ea3a",
  Offscreen: "ea3b",
  Notvisible: "ea3c",
  Visible: "ea3d",
  Adjust: "ea3e",
  PC: "ea3f",
  Mobile: "ea40",
  Pad: "ea41",
  Scanthecode: "ea42",
  Scan: "ea43",
  Screenshot: "ea44",
  Rotation: "ea45",
  voice: "ea46",
  Video: "ea47",
  Location: "ea48",
  Clock: "ea49",
  Print: "ea4a",
  Member: "ea4b",
  WorkWeChat: "ea4c",
  DingTalk: "ea4d",
  EnterpriseWeChat2: "ea4e",
  Groupmanagement: "ea4f",
  Feishu: "ea50",
  Stationletter: "ea51",
  Email1: "ea52",
  WeChat: "ea53",
  ServiceAccount: "ea54",
  Subscribed: "ea55",
  Dingtalk: "ea56",
  Information: "ea57",
  Assistant: "ea58",
  ai: "ea59",
  Inquireabout: "ea5a",
  IFrame: "ea5b",
  Integratio: "ea5c",
  close: "ea5d",
  Close: "ea5e",
  Addgroup: "ea5f",
  deletegroup: "ea60",
  Relateddata: "ea61",
  Enlarge1: "ea62",
  Narrow2: "ea63",
  "map-search": "ea64",
  Corner: "ea65",
  text1: "ea66",
  Onlinemap: "ea67",
  Maptile: "ea68",
  Dataexport: "ea69",
  Word: "ea6a",
  Excel: "ea6b",
  PPT: "ea6c",
  PDF: "ea6d",
  Video1: "ea6e",
  Audio: "ea6f",
  Txt: "ea70",
  Zip: "ea71",
  file: "ea72",
  richtext: "ea73",
  Onlinemap1: "ea74",
  Maptile1: "ea75",
  Ai2: "ea76",
  Guide: "ea77",
  Button: "ea78",
  Menus: "ea79",
  "richtext-Copy": "ea7a",
  "richtext-Copy-2": "ea7b",
  "richtext-Copy-3": "ea7c",
  "richtext-Copy-4": "ea7d",
  Split: "ea7e",
  AI: "ea7f",
  Form1: "ea80",
  Fields: "ea81",
  Project: "ea82",
  More1: "ea83",
  Notstarted: "ea84",
  Inprocess: "ea85",
  Completed: "ea86",
  Completed1: "ea87",
  More2: "ea88",
  AIoffice: "ea89",
  statistics: "ea8a",
  Expand3: "ea8b",
  list: "ea8c",
  "list-Copy": "ea8d",
  Grid: "ea8e",
  Calendar: "ea8f",
  Schedule: "ea90",
  tableview: "ea91",
  Gallery: "ea92",
  Copy1: "ea93",
  Mailbox: "ea94",
  Automation1: "ea95",
  Avatar: "ea96"
};
function re(e) {
  const t = M[e];
  return t ? `&#x${t};` : void 0;
}
const ae = (e, t, r) => {
  if (!r)
    return {
      translated: ""
    };
  const n = new Map(t.map((o) => [o.widget.widgetName, o.label]));
  for (const o of t)
    if (o.widget.type === "subform" && o.widget.items) {
      for (const l of o.widget.items)
        if ("widget" in l && !("options" in l)) {
          const s = `${o.widget.widgetName}.${l.widget.widgetName}`;
          n.set(s, l.label);
        }
    }
  const a = [], i = e.replace(
    /\$\{(_widget_\d+(?:\._widget_\d+)?)\}/g,
    (o, l) => {
      const { translated: s, meta: u } = r(l);
      return u && a.push(u), s;
    }
  );
  return {
    meta: a.length ? A(a) : null,
    translated: (i != null ? i : "").trim()
  };
};
export {
  Y as DATA_COUNT_PER_BATCH,
  v as FIELD_TYPE_OPERATOR_MAP,
  B as GetLoadingMsg,
  L as GetPartErrMsg,
  O as GetQueryResult,
  j as GetSafeFormStructure,
  S as IsErrorPart,
  R as IsFakeMsgPart,
  F as IsFileGroupPart,
  T as IsFilePart,
  I as IsLoadingPart,
  D as IsQueryResultPart,
  K as OPERATOR_LABEL_MAP,
  C as WHITE_LIST_FIELDS_SET,
  te as bsConditionParse2Condition,
  ee as conditionStringify2bsCondition,
  Q as createFieldPartsExtractor,
  H as createGetFieldJsonInfo,
  J as createPartTypeChecker,
  c as extractTextPartMeta,
  A as flatArr,
  X as getAvailableOperators,
  Z as getDefaultOperator,
  re as getIconUnicode,
  W as getMetaErrorMsg,
  z as imageUrlToBase64,
  U as injectHostStylesIntoShadow,
  V as isHelperCondMet,
  ne as mergeConsecutiveTargets,
  ae as promptParser,
  $ as safeParseJson,
  G as valueNormalizer
};
//# sourceMappingURL=ai-feat-utils.js.map
